import React, { useEffect, useState } from "react";
import AccountLayout from "./AccountLayout";
import { t } from "i18next";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import NoData from "../../component/NoData";

const FreeSpin = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    status: "active",
    page: 1,
    limit: 100,
  });

  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getTurnover, filter);
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
      }
    }
  };

//   useEffect(() => {
//     getData();
//   }, []);

  return (
    <AccountLayout title={'Free Spin'}>
      <ng-component className="ng-star-inserted">
        <router-outlet />
        <ng-component
          _nghost-serverapp-c2794537353
          className="ng-tns-c2794537353-13 ng-star-inserted"
        >
          <div
            _ngcontent-serverapp-c2794537353
            className="player-top ng-tns-c2794537353-13"
          >
            <div
              _ngcontent-serverapp-c2794537353
              className="tab-btn-section ng-tns-c2794537353-13"
            >
              <app-tab-button-nav
                _ngcontent-serverapp-c2794537353
                className="ng-tns-c2794537353-13"
                _nghost-serverapp-c1328719065
              >
                <div
                  _ngcontent-serverapp-c1328719065
                  className="tab-btn tab-btn-page"
                >
                  <div
                    _ngcontent-serverapp-c1328719065
                    className="line"
                    style={{
                      width: "calc(50%)",
                      "-webkit-transform": "translate(0%, 0px)",
                      "-ms-transform": "translate(0%, 0px)",
                      transform: "translate(0%, 0px)",
                    }}
                  />
                  <div
                    _ngcontent-serverapp-c1328719065
                    drctablinkactive="active"
                    className="btn ng-star-inserted active"
                    data-tab-current="current"
                  >
                    <div _ngcontent-serverapp-c1328719065 className="text">
                      {t("Active")}
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c1328719065
                    drctablinkactive="active"
                    className="btn ng-star-inserted"
                    data-tab-current
                  >
                    <div _ngcontent-serverapp-c1328719065 className="text">
                      {t("Completed")}
                    </div>
                  </div>
                </div>
                <div
                  _ngcontent-serverapp-c1328719065
                  className="tab-btn-page-underline"
                />
              </app-tab-button-nav>
            </div>
          </div>
          <div
            _ngcontent-serverapp-c2794537353
            className="tab-content tab-content-page ng-tns-c2794537353-13"
          >
            <div
              _ngcontent-serverapp-c2794537353
              className="ng-tns-c2794537353-13 ng-trigger ng-trigger-tabPageTriggerAni"
            >
              <router-outlet
                _ngcontent-serverapp-c2794537353
                className="ng-tns-c2794537353-13"
              />
              <ng-component
                _nghost-serverapp-c3114357537
                className="ng-tns-c3114357537-16 ng-star-inserted"
                style={{}}
              >
                <ul
                  _ngcontent-serverapp-c3114357537
                  className="ticket-wrap ng-tns-c3114357537-16 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted"
                >
                 <NoData/>
                </ul>
              </ng-component>
            </div>
          </div>
        </ng-component>
      </ng-component>
    </AccountLayout>
  );
};

export default FreeSpin;
